import { PopoutUserInformation } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutUserInformation/PopoutUserInformation";

export { PopoutUserInformation };
